import { Injectable } from '@angular/core';
import { HttpUtilService } from './http-util.service';
import { Subject, Observable } from 'rxjs';
import { environment } from '@env/environment';

/**Provides an integrface with the data definitions and scheme in the database */
@Injectable({
  providedIn: 'root'
})

export class DataModelService {

  constructor(private http: HttpUtilService) { }
  /** Subject for monitoring change trigers to types reference*/
  private updateTypeListListener = new Subject;
  /** Subscribe to the update type list changes */
  updateTypeListTrigger(): Observable<any> {
    return this.updateTypeListListener;
  }
  /** Trigger an update types list change */
  updateTypes() {
    this.updateTypeListListener.next();
  }
  /**
   * GET a list of types
   * @param id Id of specific type to get details abount
   */
  getTypes(id?): Observable<any[]> {
    return this.http.request('GET', environment.apiRoot + '/types' + (id ? ('/' + id) : ''), null, null, true);
  }
  /**
   * Get a list of available categories in the current instance
   * @param includeTypes Include a list of type for each category
   * @param id Get details abount a specific category
   */
  getCategories(includeTypes?: boolean, id?): Observable<any> {
    return this.http.request('GET', environment.apiRoot + '/categories' + (id ? ('/' + id) : '')
      + (includeTypes ? '?include=types' : ''), null, null, true);
  }
  /**
   * Create a new category in the current instance
   * @param title Title of category
   * @param iconClass Icon for category
   */
  createCategory(title: string, iconClass: string): Observable<any> {
    const categoryData = {
      'title': title,
      'json_data': {
        'iconClass': iconClass
      }
    };
    return this.http.request('POST', environment.apiRoot + '/categories', categoryData, null, true);
  }
  /**
   * Update an existing category
   * @param catId ID of categroy to update
   * @param category Details for the update
   *          category = {
   *    json_data : {}
   * }
   */
  updateCategory(catId: number | string, category): Observable<any> {
    // var category = {
    //     json_data : {}
    // }
    return this.http.request('PUT', environment.apiRoot + '/categories/' + catId, category, null, true);
  }
  /**
   * Create a new data type in the current instance
   * @param name Name of the new type
   * @param categoryId Category the new type belongs to
   */
  createType(name: string, categoryId: number | string): Observable<any> {
    const newModel = {
      name,
      categoryId
    };
    return this.http.request('POST', environment.apiRoot + '/types', newModel, null, true);
  }
  /**
   * Change the categroy for a data type in the current instance
   * @param id Id/name on data type
   * @param categoryId New category for the data type
   */
  updateType(id: string | number, categoryId: string | number): Observable<any> {
    const update = {
      categoryId: categoryId
    };
    return this.http.request('PUT', environment.apiRoot + '/types/' + id, update, null, true);
  }
  /**
   * Delete a data type from the current insatcne
   * @param id ID/name of data type
   */
  deleteType(id: string | number): Observable<any> {
    return this.http.request('DELETE', environment.apiRoot + '/types/' + id, null, null, true);
  }
  /**
   * Get a list of keys for the specified data type
   * @param modelId ID/name of data type
   * @param keyName Specific key to get details about
   */
  getKeys(modelId: string | number, keyName?: string): Observable<any[]> {
    return this.http.request('GET', environment.apiRoot + '/types/' + modelId
      + '/keys' + (keyName ? ('/' + keyName) : ''), null, null, true);
  }
  /**
   * Create a new key for the specified data type
   * @param modelId ID/name of data type to add the key
   * @param name Key to be added
   * @param json_data data object with details about the key
   * @param encrypted Should data using this key be encrypted in the database
   */
  addKey(modelId: string | number, name: string, json_data, encrypted: boolean): Observable<any> {
    const newKey = {
       name,
       json_data,
       encrypted
    };

    return this.http.request('POST', environment.apiRoot + '/types/' + modelId + '/keys', newKey, null, true);
  }
  /**
   * Update the details about a key in a data item
   * @param modelId id/name of data type
   * @param key details about the key to update
   */
  updateKey(modelId: string|number, key) {
    // var key = {
    //     json_data : key.json_data,
    //     encrypted : key.encrypted,
    //     item_desc : key.item_desc
    // }

    return this.http.request('PUT', environment.apiRoot + '/types/' + modelId + '/keys/' + key.name, key, null, true);
  }
  /**
   * Delete a key fropm a data type
   * @param modelId ID/name of data type
   * @param name Name of key
   */
  deleteKey(modelId: string|number, name: string) {
    return this.http.request('DELETE', environment.apiRoot + '/types/' + modelId + '/keys/' + name, null, null, true);
  }
}
